// Orders — created when a quote is won. M2 Phase 5.6 territory.

export function OrdersPage() {
  return (
    <div className="max-w-5xl mx-auto">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-bold text-navy">Orders</h1>
      </div>

      <div className="bg-paper border border-line rounded p-6 text-center text-text-mute">
        <div className="text-4xl mb-2">📦</div>
        <div className="font-semibold mb-1">No orders yet</div>
        <p className="text-sm">
          Orders auto-create when a quote moves to <code className="bg-bg px-1 rounded">status: 'won'</code>.
          Status transitions (draft → in_production → shipped → closed) handled in M2 Phase 5.6.
        </p>
      </div>
    </div>
  );
}
